export default __webpack_public_path__ + "static/21-64bd33a8dff7e19e60989c10e6111d2c.jpg";